import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { findProducts } from "../Redux/Customers/Product/Action";
import { findCategories } from "../Redux/Customers/Categories/Action";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Categories = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { customersProduct } = useSelector((store) => store);
    const { categories, loading: categoriesLoading } = useSelector((state) => state.categories);
    const audioRef = useRef(null);

    const [selectedCategory, setSelectedCategory] = useState(""); // Store the selected category
    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Control sidebar visibility

    useEffect(() => {
        // Fetch categories when component mounts
        dispatch(findCategories());
    }, [dispatch]);

    useEffect(() => {
        // Fetch products based on the selected category
        const data = {
            category: selectedCategory,
            colors: [],
            sizes: [],
            minPrice: 0,
            maxPrice: 100000,
            minDiscount: 0,
            sort: "price_low",
            pageNumber: 1,
            pageSize: 10,
            stock: "in_stock",
        };
        dispatch(findProducts(data));
    }, [dispatch, selectedCategory]);

    const handleProductClick = (productId) => {
        if (audioRef.current) {
            audioRef.current.play();
        }
        setTimeout(() => {
            navigate(`/products/${productId}`);
        }, 1000);
    };

    const handleCategoryClick = (categoryName) => {
        setSelectedCategory(categoryName); // Update selected category
        setIsSidebarOpen(false); // Close sidebar on mobile after selecting a category
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <Navbar />
            <div className="relative min-h-screen h-fit lg:pt-32 pt-16 flex">
                {/* Background */}
                <div className="absolute inset-0 -z-10 h-full w-full items-center px-5 py-24 bg-[radial-gradient(125%_125%_at_50%_10%,#000_40%,#63e_100%)]"></div>

                {/* Hamburger Icon for small screens */}
                <div className="fixed  p-4 z-20 lg:hidden">
                    <button
                        onClick={toggleSidebar}
                        className="text-white text-3xl focus:outline-none"
                    >
                        {isSidebarOpen ? "✖" : "☰"} {/* Show ✖ when sidebar is open */}
                    </button>
                </div>

                {/* Sidebar - Categories */}
                <aside
                    className={`lg:w-1/4 w-3/4 fixed lg:relative h-screen lg:h-auto lg:block bg-gray-800 text-white p-4 z-10 transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
                        } transition-transform duration-300 ease-in-out lg:translate-x-0 lg:transition-none pt-14`}
                >
                    <h2 className="text-2xl font-bold mb-4">Categories</h2>
                    {categoriesLoading ? (
                        <p>Loading...</p>
                    ) : (
                        <ul>
                            <li
                                className={`cursor-pointer p-2 rounded hover:bg-gray-600 ${selectedCategory === "" ? "bg-gray-700" : ""
                                    }`}
                                onClick={() => handleCategoryClick("")}
                            >
                                All Categories
                            </li>
                            {categories.map((category) => (
                                <li
                                    key={category._id}
                                    className={`cursor-pointer p-2 rounded hover:bg-gray-600 ${selectedCategory === category.name ? "bg-gray-700" : ""
                                        }`}
                                    onClick={() => handleCategoryClick(category.name)}
                                >
                                    {category.name}
                                </li>
                            ))}
                        </ul>
                    )}
                </aside>

                {/* Main Content - Products */}
                <main className="w-full lg:w-3/4 lg:ml-0 ml-auto p-8 transition-all duration-300 ease-in-out">
                    {/* Featured Collection Section */}
                    <section className="flex flex-col">
                        {/* Header Section */}
                        <div className="border-b-2 flex justify-between items-center py-4 pt-5">
                            <h1 className="text-3xl sm:text-4xl font-bold text-white text-center lg:text-start w-full">Featured Collection</h1>
                        </div>

                        {/* Products Grid or No Products Found Message */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-8 p-2 sm:p-3 lg:p-5">
                            {customersProduct?.products?.length > 0 ? (
                                customersProduct.products.map((product) => (
                                    <div
                                        key={product._id}
                                        className="text-center cursor-pointer"
                                        onClick={() => handleProductClick(product?._id)}
                                    >
                                        <img
                                            className="border shadow-md shadow-pink-500 border-pink-900 rounded w-full h-[300px] sm:h-[350px] object-cover"
                                            src={product?.imageUrl}
                                            alt={product?.title}
                                        />
                                        <div className="flex justify-between items-center mt-4 px-2">
                                            <p className="text-white text-sm sm:text-base">{product?.title}</p>
                                            <p className="text-white text-sm sm:text-base">{product?.discountedPrice} ₹</p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-white text-xl col-span-full text-center">No products found in this category.</p>
                            )}
                        </div>
                    </section>
                </main>

                {/* Audio element */}
                <audio ref={audioRef} src="/audio1.mp3" />
            </div>
            <Footer />
        </>
    );
};

export default Categories;
